import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'App/store';
import { useStatisticsFilterContext } from 'domains/Statistics/hooks';
import useStatisticsStoredFilters from 'domains/Statistics/hooks/useStatisticsStoredFilters';
import {
  getSalesChannelsRevenueData,
  getSalesChannelsRevenueStatus,
} from 'domains/Statistics/selectors';
import { getSalesChannelsRevenueAction } from 'domains/Statistics/statisticsSlice';

function useGetSalesChannelsRevenue() {
  const dispatch = useAppDispatch();
  const salesChannelsRevenue = useSelector(getSalesChannelsRevenueData);
  const status = useSelector(getSalesChannelsRevenueStatus);
  const { ...filters } = useStatisticsFilterContext();

  const fetchSalesChannelsRevenue = useCallback(() => {
    dispatch(getSalesChannelsRevenueAction());
  }, [dispatch]);

  useStatisticsStoredFilters(fetchSalesChannelsRevenue);

  return {
    ...status,
    ...filters,
    salesChannelsRevenue,
    fetchSalesChannelsRevenue,
  };
}

export default useGetSalesChannelsRevenue;
